import { CouponActivityType } from '@tiendanube/common/src/domains/store-activity-logs/enums';
import { EventTypeIconConfig, eventTypeIconConfigMap } from './types';

export const mapEventTypeToIconConfig = (
  eventType: CouponActivityType,
): EventTypeIconConfig => eventTypeIconConfigMap[eventType];
